<template>
  <div class="bg" :style="{ fontFamily: fonts,background: 'url(' + bgUrl + ') no-repeat center / 100% 100%' }">
    <home-header @changeFont="changeF"></home-header>
    <div class="bgbody">
      <div class="center">
        <div class="faceRegister">
          <div class="header">请刷脸签到，谢谢！</div>
          <div class="videoBox boxCon">
            <!-- <img src="../assets/user.png" alt=""> -->
            <div class="playbox imgBox" id="canvasBox">
              <video
                id="webcam"
                width="100%"
                height="100%"
                ref="videoDom"
                preload
                autoplay
                loop
                muted
                v-show="bol"
              ></video>
              <img
                class="facebg bg2"
                src="../assets/facebg2.png"
                :style="{ width: vWidth + 'px', height: vHeight + 'px' }"
              />
              <img
                class="facebg"
                src="../assets/facebg.png"
                :style="{ width: vWidth + 'px', height: vHeight + 'px' }"
              />
              <canvas ref="canvasDOM" id="face_detect"></canvas>
              <canvas
                class="faceImgcanvas"
                id="faceImgcanvas"
                style="display:none;"
              ></canvas>
            </div>
            <div class="imgtext">{{ isdetected }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HomeHeader from "./header";
import { Toastinit } from "@/utils/toast";
import {
  allLists,
  cleanLogins,
  antiepLogin,
  getMeetModel
} from "@/utils/request";
export default {
  components: {
    HomeHeader
  },
  data() {
    return {
      fonts: "",
      video: null,
      modelClock: null,
      bol: true,
      bol1: true,
      curType: "", //防疫人员1， 保洁人员 2
      meetingId: "",
      meetingName: "",
      timer: null,
      startTime: "",
      thisCodeId: "",
      faceImg: "",
      count: null,
      count2: 0,
      imgSrc: "",
      isdetected: "请对准需要识别的人脸",
      videoEl: {},
      canvasEL: {},
      vWidth: "",
      vHeight: "",
      trackCcv: false,
      trackTracking: false,
      autoCaptureTrackTraking: false,
      rect: {},
      isAready: false,
      // isShowQcode: true,
      erweimaId: "",
      tracker: null,
      trackTask: null,
      localMediaStream: null,
      userMediaConstraints: {
        audio: false,
        video: true
        // video: {
        //     // 摄像头翻转
        //     facingMode: 'user'
        //     }
      },
      bgUrl:''
    };
  },
  created() {},
  mounted() {
    this.equipmentName = this.$route.query.equipmentName;
    this.meetingId = this.$route.query.meetingId;
    this.meetingName = this.$route.query.meetingName;
    this.curType = this.$route.query.type;
    this.bgUrl = localStorage.getItem('bgUrl')
    // if (this.modelClock) {
    //   clearInterval(this.modelClock);
    // } else {
    //   this.modelClock = setInterval(() => {
    //     this.getMeetModels();
    //   }, 2000);
    // }

    //进入页面打开摄像头
    // this.allLists()
    //人脸识别
    // The getUserMedia interface is used for handling camera input.
    // Some browsers need a prefix so here we're covering all the options
    navigator.getUserMedia =
      navigator.getUserMedia ||
      navigator.mediaDevices.getUserMedia ||
      navigator.webkitGetUserMedia ||
      navigator.mozGetUserMedia ||
      navigator.msGetUserMedia;
    this.init();
  },
  beforeDestroy() {
    // if (this.modelClock) {
    //   clearInterval(this.modelClock);
    // }
    if (this.timer) {
      clearInterval(_this.timer);
    }
  },
  destroyed() {
    //退出页面关闭摄像头
    this.videoEl.srcObject = null;
    // this.video.srcObject.getTracks()[0].stop();
    // this.video.srcObject.getTracks()[0].closeCamera();
  },
  methods: {
    // getMeetModels() {
    //   getMeetModel().then(res => {
    //     if (Number(res.code) === 0) {
    //       this.fonts = res.data.fontStyle;
    //     }
    //   });
    // },
    // 会议室信息列表
    allLists() {
      // console.log(this.$route)
      let params = {
        meetingId: this.meetingId
      };
      allLists(params).then(res => {
        // console.log(res)
        if (res.code == 0) {
          this.startTime = res.data.pageInfoList.list[0].startTime;
          this.erweimaId = res.data.pageInfoList.list[0].id;
          // if(this.isShowQcode){
          //     // this.creatQrCode(res.data.pageInfoList.list[0].id);
          // }
          if (
            this.$route.query.homeTo &&
            this.$route.query.homeTo !== undefined
          ) {
            let _this = this;
            this.timer = setInterval(() => {
              let curdate = new Date().getTime();
              // console.log(curdate)
              let startSeconds = new Date(this.startTime).getTime();
              if (startSeconds < curdate) {
                //会议开始了
                clearInterval(_this.timer);
                _this.$router.push({
                  path: "/advertising",
                  query: {
                    equipmentName: this.equipmentName,
                    meetingId: this.meetingId,
                    name: this.name,
                    meetingName: this.meetingName
                  }
                });
              }
            }, 1000);
          }
        }
      });
    },
    // creatQrCode(id) {
    //     // console.log(document.getElementsByClassName('imgBox')[1].clientWidth)
    //     let w = document.getElementsByClassName('imgBox')[0].clientWidth
    //     var qrcode = new QRCode(this.$refs.qrCodeUrl, {
    //         text: id, // 需要转换为二维码的内容
    //         width: w*0.6,
    //         height: w*0.6,
    //         colorDark: '#000000',
    //         colorLight: '#ffffff',
    //         correctLevel: QRCode.CorrectLevel.H
    //     })
    // },
    async init() {
      let w = document.getElementsByClassName("imgBox")[0].clientWidth;
      let faceCanvas = document.getElementById("faceImgcanvas");
      let facecxt = faceCanvas.getContext("2d");

      this.videoEl = this.$refs.videoDom;
      this.canvasEL = this.$refs.canvasDOM;

      this.videoEl.width = w * 0.45;
      this.videoEl.height = w * 0.45;

      this.vWidth = w * 0.45;
      this.vHeight = w * 0.45;

      faceCanvas.width = w * 0.45;
      faceCanvas.height = w * 0.45;

      await navigator.mediaDevices
        .getUserMedia(this.userMediaConstraints)
        .then(this.getMediaStreamSuccess)
        .catch(this.getMediaStreamError);
      await this.onPlay();
    },
    async onPlay() {
      // debugHelper.log('onPlay')
      this.isdetected = "请对准需要识别的人脸";
      this.onTrackTracking();
    },
    onTrackTracking() {
      const _this = this;
      const video = this.videoEl;
      const canvas = this.canvasEL;
      const canvasContext = canvas.getContext("2d");
      const tracker = new tracking.ObjectTracker("face");
      video.src = "";
      tracker.setInitialScale(4);
      tracker.setStepSize(2);
      tracker.setEdgesDensity(0.1);
      tracking.track("#webcam", tracker, { camera: true });
      tracker.on("track", function(event) {
        // console.log(event)
        const { autoCaptureTrackTraking } = _this;
        // canvasContext.clearRect(0, 0, canvas.width, canvas.height)
        event.data.forEach(function(rect) {
          canvasContext.strokeStyle = "red";
          canvasContext.clearRect(0, 0, canvas.width, canvas.height);
          _this.plotRectangle(rect.x, rect.y, rect.width, rect.height);
        });
        if (event.data.length > 0 && _this.count != null) {
          if (_this.count < 0) _this.count = null;
          _this.count += 1;
          // console.log(_this.imgSrc);
          if (_this.count > 1) {
            // _this.saveToImgByStr(_this.imgSrc)
            _this.saveToImgByStrs(_this.imgSrc);
            _this.count = null;
            _this.isdetected = "正在比对中";
          }
        } else {
          let canvasbox = document.getElementById("canvasBox");
          if (canvasbox.getElementsByTagName("div")[0]) {
            canvasbox.getElementsByTagName("div")[0].remove();
          }
          _this.count -= 1;
          if (_this.count < 0) _this.isdetected = "请对准需要识别的人脸";
        }
      });
    },
    // checkisFace(img){
    //     let imgFace = document.getElementById('faceImg')
    //     let _this = this
    //     var tracker2 = new tracking.ObjectTracker('face')
    //     // console.log(imgFace.src)
    //     tracking.track(imgFace, tracker2);
    //     tracker2.on('track', function (event) {
    //         console.log(event)
    //         if (event.data.length>0) {
    //                 console.log(img)
    //                 _this.isdetected = '已检测到人脸'
    //                  if (context.count < 0) context.count = 0
    //                 context.count += 1
    //                  if (context.count > 6) {
    //                      _this.faceCompareALLfun(img)
    //                  }
    //         } else {
    //             // _this.count2 -= 1
    //             // if (_this.count2 < 0) _this.isdetected = '请对准需要识别的人脸'
    //             // this.isdetected = '已检测到人脸'
    //         }
    //     });
    // },
    plotRectangle(x, y, w, h) {
      let canvasbox = document.getElementById("canvasBox");
      let iW = document.getElementsByClassName("imgBox")[0].clientWidth;
      // if (w > 200) {
      if (canvasbox.getElementsByTagName("div")[0]) {
        canvasbox.getElementsByTagName("div")[0].remove();
      }
      let rect = document.createElement("div");

      let faceCanvas = document.getElementById("faceImgcanvas");
      let facecxt = faceCanvas.getContext("2d");
      // rect.classList.add('rectbox')
      const video = this.videoEl;
      canvasbox.appendChild(rect);
      // rect.setAttribute('ref','capture')
      rect.style.border = "5px solid red";
      rect.style.position = "absolute";
      rect.style.zIndex = "1000000";
      rect.style.width = w * 1.1 + "px";
      rect.style.height = h * 1.3 + "px";
      rect.style.left = video.offsetLeft / 2 + x * 0.65 + "px";
      rect.style.top = video.offsetTop / 2 + y * 0.9 + "px";

      // facecxt.rect(x * 1.1, y * 1.1, w * 1.1, h * 1.3);
      facecxt.rect(0, 0, video.width, video.height);
      facecxt.clip();
      facecxt.drawImage(video, 0, 0, video.width, video.height);

      let createCanvas = document.createElement("canvas");
      // createCanvas.width = w * 1.1;
      // createCanvas.height = h * 1.3;
      createCanvas.width = video.width;
      createCanvas.height = video.height;
      let cxt = createCanvas.getContext("2d");
      // cxt.drawImage(faceCanvas,x*1.1,y*1.1,w*1.5,h*1.5,0,0,createCanvas.width,createCanvas.height)
      cxt.drawImage(
        faceCanvas,
        0,
        0,
        video.width,
        video.height,
        0,
        0,
        createCanvas.width,
        createCanvas.height
      );
      this.imgSrc = createCanvas.toDataURL("image/png");
      // } else {
      //   this.isdetected = "请将人脸靠近镜头";
      // }
    },
    getMediaStreamSuccess(stream) {
      // window.stream = stream // make stream available to browser console
      // this.videoEl.srcObject = stream
      try {
        // window.stream = stream;
        //兼容webkit内核浏览器
        var CompatibleURL = window.URL || window.webkitURL;
        //将视频流设置为video元素的源
        // this.videoEl.src = CompatibleURL.createObjectURL(stream);   // 此处的代码将会报错  解决的办法是将video的srcObject属性指向stream即可
        this.videoEl.srcObject =
          stream || CompatibleURL.createObjectURL(stream);
        // this.videoEl.play()
      } catch (error) {
        this.videoEl.src = window.URL.createObjectURL(stream);
      }
      // this.videocodeEl.srcObject = stream
    },
    // 视频媒体流失败
    getMediaStreamError(error) {
      // alert('视频媒体流获取错误' + error)
    },
    //人脸识别接口
    saveToImgByStrs(img) {
      // console.log(img);
      return new Promise((resolve, reject) => {
        console.log(img);
        const ImgData = {
          // meetingId: this.meetingId,
          imgByte: img,
          meetingId: this.meetingId
        };
        if (Number(this.curType) === 1) {
          //防疫人员
          antiepLogin(ImgData)
            .then(res => {
              // console.log(res)
              if (Number(res.code) === 0) {
                this.$router.push({
                  path: "/innerRegisterOk",
                  query: {
                    equipmentName: this.equipmentName,
                    meetingId: this.meetingId,
                    meetingName: this.name,
                    meetingName: this.meetingName,
                    id: this.id
                  }
                });
              } else {
                // this.isdetected = res.msg;
                // this.$message.error(res.msg);
                Toastinit({
                  time: 2000,
                  message: res.msg,
                  type: "error"
                });
                this.count = null;
                this.isdetected = "请对准需要识别的人脸";
              }
            })
            .catch(err => {
              this.isdetected = "连接失败";
              // this.onPlay()
            })
            .finally(() => {
              this.imgSrc = "";
            });
        } else if (Number(this.curType) === 2) {
          //保洁人员
          cleanLogins(ImgData)
            .then(res => {
              // console.log(res)
              if (Number(res.code) === 0) {
                this.count = null;
                this.$router.push({
                  path: "/registerOk",
                  query: {
                    equipmentName: this.equipmentName,
                    meetingId: this.meetingId,
                    meetingName: this.name,
                    meetingName: this.meetingName,
                    id: this.id
                  }
                });
              } else {
                // this.$message.error(res.msg);
                Toastinit({
                  time: 2000,
                  message: res.msg,
                  type: "error"
                });
                this.count = null;
                this.isdetected = "请对准需要识别的人脸";
              }
            })
            .catch(err => {
              this.isdetected = "连接失败";
              // this.onPlay()
            })
            .finally(() => {
              this.imgSrc = "";
            });
        }
      });
    },
    faceCompareALLfun() {
      // console.log(this.imgSrc);
      this.saveToImgByStrs(this.imgSrc);
    },
    changeF(font) {
      this.fonts = font;
    }
  }
};
</script>

<style lang="less" scoped>
.bg {
  color: #fff;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  font-size: 36px;
  .bgbody {
    position: fixed;
    top: 10%;
    left: 0;
    right: 0;
    bottom: 0;
    .center {
      width: 50%;
      margin: 5% auto;
      background: rgba(255, 255, 255, 0.1);
      padding: 3% 0 1%;
      height: 70%;
      .faceRegister {
        position: relative;
        height: 100%;
        .header {
          text-align: center;
          font-size: 40px;
          margin-bottom: 5%;
          letter-spacing: 3px;
        }
        .videoBox {
          text-align: center;
          // position: relative;
          margin-bottom: 2%;
          height: 80%;
          img {
            width: 52%;
          }
          .playbox {
            text-align: center;
            position: relative;
            height: 85%;
            .faceImg {
              width: 100%;
              position: absolute;
              top: 20%;
              left: 0;
              transform: translate(-50%, -50%); /* 50%为自身尺寸的一半 */
            }
            .facebg {
              position: absolute;
              left: 50%;
              top: 0;
              transform: translate(-50%);
              object-fit: fill;
              z-index: 10;
              width: 459px;
              height: 459px;
            }
            .bg2 {
              z-index: 20;
            }
            video {
              position: absolute;
              left: 50%;
              top: 0;
              transform: translate(-50%);
              object-fit: fill;
              border-radius: 50%;
            }
            .faceImgcanvas {
              position: absolute;
              right: -200px;
              top: 0;
              transform: translate(-50%);
            }
          }
        }
        .registerBottom {
          text-align: center;
          font-size: 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/innerRegister.vue